function isObject(value: unknown) {
  return Object.prototype.toString.call(value) === '[object Object]';
}

function isLocalStorageAvailable() {
  if (typeof globalThis !== 'undefined') {
    return 'localStorage' in globalThis && globalThis['localStorage'] !== null;
  }
  return false;
}

export class LocalStorageService {
  getItem(key: string) {
    if (isLocalStorageAvailable()) {
      return globalThis.localStorage.getItem(key);
    }
    return null;
  }

  setItem(key: string, value: unknown) {
    if (isLocalStorageAvailable()) {
      if (Array.isArray(value) || isObject(value)) {
        globalThis.localStorage.setItem(key, JSON.stringify(value));
      } else {
        globalThis.localStorage.setItem(key, `${value ?? ''}`);
      }
    }
  }

  removeItem(key: string) {
    if (isLocalStorageAvailable()) {
      globalThis.localStorage.removeItem(key);
    }
  }

  clear() {
    if (isLocalStorageAvailable()) {
      globalThis.localStorage.clear();
    }
  }
}

export const localStorageService = new LocalStorageService();
